import { graphql, useStaticQuery } from "gatsby"
import { useLocale } from ".."

export const useSiteQueryThree = () => {
  const locale = useLocale()

  const {
    allContentfulDigitupGlobalCustomFields: { edges },
  } = useStaticQuery(
    graphql`
      query globalCustomFields {
        allContentfulDigitupGlobalCustomFields {
          edges {
            node {
              node_locale
              searchByTags
              shareArticleText
              moreAuthors
              headerText
              getAQuoteButton
              allServices
              skipToContent
              newsletterErrorMessage2
            }
          }
        }
      }
    `
  )

  const localeData = locale
    ? edges.filter(({ node }) => node.node_locale === locale)
    : edges.filter(({ node }) => node.node_locale === "en-US")
  const site = localeData.reduce((acc, val) => ({ ...acc, ...val.node }), {})


  return site
}
